import { render } from "./ASwitcher.vue?vue&type=template&id=84a3e42e"
import script from "./ASwitcher.vue?vue&type=script&lang=js"
export * from "./ASwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__